import React from 'react';
import { useLocation } from 'wouter';
import NavigationTabs from '../navigation/navigationTab/NavigationTabs';
import styles from './layout.module.css';
import { useSubscriptionContext } from '@/contexts/SubscriptionContext';
import AnalyticsBlockedOverlay from '@/components/AnalyticsBlockedOverlay/AnalyticsBlockedOverlay';
import AnalyticsBySkuMockPage from '@/components/AnalyticsBySkuMockPage/AnalyticsBySkuMockPage';

export default function AnalyticsLayout({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  const { subscription, refetchSubscription, isFetchingSubscriptions } = useSubscriptionContext();

  console.log("subscription: ", subscription);

  const isStandardPlan = subscription?.planCode && subscription.planCode.indexOf('professional') < 0;

  return (
    <div className={styles.container}>
      <NavigationTabs 
          tabs={[
            // { id: 'profit-overview', label: 'Profit Overview', href: '/profit-overview' },
            // { id: 'profit-loss', label: 'P&L', href: '/profit-loss' },
            { id: 'profit-by-sku', label: 'SKU Profitability', href: '/profit-by-sku', isActive: location.startsWith('/profit-by-sku'), isBeta: true },
            { id: 'profit-by-asin', label: 'ASIN Profitability', href: '/profit-by-asin', isActive: location.startsWith('/profit-by-asin'), isBeta: true },
            { id: 'profit-by-category', label: 'Category Profitability', href: '/profit-by-category', isActive: location.startsWith('/profit-by-category'), isBeta: true },
          ]}
      />
      <div>
        {!isFetchingSubscriptions && isStandardPlan ? <AnalyticsBySkuMockPage /> : children}
        {!isFetchingSubscriptions && isStandardPlan && <AnalyticsBlockedOverlay />}
      </div>
    </div>
  );
}   